import React from 'react'

import { Corpus } from 'components/base/Text'
import { Danger } from 'components/base/Button'
import DeleteTeamConfirmationModal from './ConfirmationModal'

type DeleteTeamLayoutProps = {
  deleteOrganization: () => void
}

export default function DeleteTeamLayout({
  deleteOrganization,
}: DeleteTeamLayoutProps) {
  const handleTeamRemoval = React.useCallback(
    () => {
      if (
        window.confirm(
          `We apologize for being so annoying but we really want to make sure you understand this cannot be undone!

Please confirm a last time if you really want to do this.`
        )
      ) {
        deleteOrganization()
      }
    },
    [deleteOrganization]
  )

  return (
    <>
      <Corpus className="margin-bottom-large">
        You will receive a full backup of your team and each member will receive
        an individual backup as well.
      </Corpus>
      <DeleteTeamConfirmationModal onConfirm={handleTeamRemoval}>
        <Danger type="button" className="margin-bottom-huge">
          Delete my team
        </Danger>
      </DeleteTeamConfirmationModal>
    </>
  )
}
